import { render, staticRenderFns } from "./UIModalHeader.vue?vue&type=template&id=cfc7d9f6"
import script from "./UIModalHeader.vue?vue&type=script&lang=js"
export * from "./UIModalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports